import { Page } from '@shopify/polaris';
import type { ReactNode } from 'react';

/**
 * Thin page wrapper. Keeps `Page` props (title, backAction) at call sites so
 * each screen controls its own header — we only centralise the outer padding
 * and the max-width that matches Polaris admin conventions.
 */
export function AppPage({
  title,
  subtitle,
  backAction,
  primaryAction,
  secondaryActions,
  children,
}: {
  title?: string;
  subtitle?: string;
  backAction?: { content: string; onAction: () => void };
  primaryAction?: { content: string; onAction: () => void; loading?: boolean; disabled?: boolean };
  secondaryActions?: Array<{ content: string; onAction: () => void; disabled?: boolean }>;
  children: ReactNode;
}): JSX.Element {
  return (
    <Page
      title={title}
      subtitle={subtitle}
      backAction={backAction}
      primaryAction={primaryAction}
      secondaryActions={secondaryActions}
    >
      {children}
    </Page>
  );
}
